/**
 * Page de connexion FrontOffice
 */

import { useState, FormEvent, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth, getBrandInfo } from '@e-store/shared';
import './auth.css';

export function LoginPage() {
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setInfoMessage('');
    setIsSubmitting(true);

    // Le backend accepte soit email soit username dans le champ "email"
    const result = await login({ email: identifier, password, portal: 'frontoffice' as const });

    if (!result.success) {
      if (result.mustChangePassword && result.emailSent) {
        setInfoMessage('Un email vous a été envoyé pour définir votre nouveau mot de passe.');
        setIsSubmitting(false);
        return;
      }
      setError(result.error || 'Erreur de connexion');
      setIsSubmitting(false);
    }
  };

  return (
    <div className="auth-page frontoffice">
      <div className="auth-container">
        <div className="auth-header">
          <h1>{getBrandInfo().name}</h1>
          <h2>Boutique en ligne</h2>
        </div>

        {error && <div className="error-message">{error}</div>}

        {infoMessage && (
          <div className="info-message">
            {infoMessage}
            <p className="info-hint">
              Veuillez consulter votre boîte mail. N'oubliez pas de vérifier vos spams.
            </p>
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="identifier">Email ou Nom d'utilisateur</label>
            <input
              type="text"
              id="identifier"
              value={identifier}
              onChange={(e) => setIdentifier(e.target.value)}
              placeholder="votre@email.com ou votre_pseudo"
              required
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Mot de passe</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Votre mot de passe"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Connexion...' : 'Se connecter'}
          </button>
        </form>

        <div className="auth-links">
          <Link to="/forgot-password" className="link">
            Mot de passe oublié ?
          </Link>
        </div>

        <div className="auth-footer">
          <p>Pas encore de compte ?</p>
          <Link to="/register" className="btn-secondary">
            Créer un compte
          </Link>
        </div>

        <div className="back-link">
          <Link to="/">&larr; Retour à la boutique</Link>
        </div>
      </div>
    </div>
  );
}
